var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('vx-card',[_c('ag-grid-vue',{staticClass:"ag-theme-alpine",staticStyle:{"width":"100%","height":"450px"},attrs:{"defaultColDef":_vm.defaultColDef,"columnDefs":_vm.columnDefs,"rowData":_vm.rowData,"localeText":_vm.localeText,"pagination":true},on:{"grid-ready":_vm.onGridReady,"first-data-rendered":_vm.onFirstDataRendered}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }